import { createFileRoute, redirect } from '@tanstack/react-router'
import { isAdminUser } from '@/lib/role-guards'
import { AdminApplicationsPage } from '@/features/admin/applications'
import { ApplicationListSkeleton } from '@/features/admin/applications/components/ApplicationListSkeleton'
import { queryClient } from '@/lib/query'
import {
  getApplications,
  getGetApplicationsQueryKey,
} from '@/utils/api/membership-service'

export const Route = createFileRoute('/_authenticated/admin/applications')({
  beforeLoad: ({ context }) => {
    if (context.auth.isLoading) {
      return
    }
    if (!isAdminUser(context.auth.user)) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: AdminApplicationsPage,
  pendingComponent: ApplicationListSkeleton,
  loader: async () => {
    await queryClient.ensureQueryData({
      queryKey: getGetApplicationsQueryKey(),
      queryFn: () => getApplications(),
    })
  },
})
